// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/js/bb6f491294486c3372d3.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"3fcc40606eabf3c85250","150":"5efab206bee62035a4f9","151":"5763202ce2e2eb866690"}[chunkId] + ".chunk.js";
};